import { AfterViewInit, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiBadgeComponent } from '@uigy/shared/components/ui-badge/ui-badge.component';
import { MatRippleModule } from '@angular/material/core';
import { NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';
import { KpiSmallBaseComponent } from '@uigy/shared/components/widgets/kpi-small/kpi-small-base.component';

@Component({
    selector: 'app-ui-kpi-small',
    imports: [
        UiBadgeComponent,
        MatRippleModule,
        NgClass,
        MatTooltip
    ],
    templateUrl: './kpi-small.component.html',
    styleUrl: './kpi-small.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpiSmallComponent extends KpiSmallBaseComponent implements AfterViewInit {
  public count = input.required<number>();

  constructor() {
    super();
  }

  public ngAfterViewInit(): void {
    this.isLaptopScreen.set(window.innerWidth < this.LARGE_SCREEN);
  }
}
